import React from "react";

import { Shimmer, ShimmerKeyframes } from "./Shimmer";
import { WorkOrderCardSkeleton } from "@shared/ui/WorkOrderCard";

type Props = {
  rowCount?: number;
};

const d = (n: number) => `${n}s`;

const WorkOrderListSkeletonRow = ({ base }: { base: number }) => (
  <div className="flex items-center gap-lg py-md px-lg border-solid border-0 border-b border-primary">
    <Shimmer
      className="w-2xs h-4xl rounded-full flex-shrink-0"
      delay={d(base)}
    />

    <div className="flex flex-col gap-xs flex-1 min-w-0">
      <div className="flex items-center gap-sm">
        <Shimmer className="h-md w-[60px] rounded" delay={d(base)} />
        <Shimmer className="h-md w-[180px] rounded" delay={d(base + 0.05)} />
      </div>
      <div className="flex items-center gap-sm">
        <Shimmer className="h-sm w-[100px] rounded" delay={d(base + 0.1)} />
        <Shimmer className="h-sm w-[140px] rounded" delay={d(base + 0.15)} />
      </div>
    </div>

    <Shimmer
      className="h-xl w-[80px] rounded-full hidden md:block"
      delay={d(base + 0.2)}
    />

    <div className="flex items-center gap-2xs flex-shrink-0">
      <Shimmer className="w-2xl h-2xl rounded-full" delay={d(base + 0.25)} />
      <Shimmer
        className="w-2xl h-2xl rounded-full -ml-sm hidden sm:block"
        delay={d(base + 0.3)}
      />
    </div>

    <Shimmer
      className="h-md w-[80px] rounded hidden lg:block"
      delay={d(base + 0.35)}
    />
  </div>
);

const WorkOrderListSkeleton = ({ rowCount = 8 }: Props) => (
  <>
    <ShimmerKeyframes />
    <div className="flex flex-col space-y-2">
      {Array.from({ length: rowCount }).map((_, i) => (
        <WorkOrderCardSkeleton key={i} />
      ))}
    </div>
  </>
);

export default WorkOrderListSkeleton;
